import { useAuth } from '../context/AuthContext';

/**
 * Returns billing access flags based on the user's assigned stores.
 *
 * - Main-store users: have 0 or >1 stores (no single-store restriction)
 * - Sub-store users:  have exactly 1 store assigned
 */
export function useBillingAccess() {
  const { user } = useAuth();

  // JWT decoded payload has `stores` (array of store ObjectIds)
  const stores = user?.stores ?? [];

  // A user with exactly one store is a sub-store user
  const isSubStore  = stores.length === 1;
  const isMainStore = !isSubStore;

  const canManageUsers = isMainStore;

  const storeId = isSubStore ? stores[0] : (user?.storeId ?? null);

  return {
    isMainStore,
    isSubStore,
    canManageUsers,
    storeId,
    storeIds: stores,
  };
}
